import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './OperatingLayer.css';

const OperatingLayer = () => {
  const [activeTab, setActiveTab] = useState('operator');

  const entityDetails = {
    buyer: {
      title: 'Buyer Layer',
      badge: 'Procurement Engine',
      role: 'Sources products, configures orders, and executes wholesale settlement.',
      features: [
        'Structured specification ordering (Gross wt, Net wt, Purity, Karatage)',
        'Direct multi-seller RFQ and order placement',
        'Transparent bullion breakdown and making charge quotes',
        'End-to-end custody and tracking visibility',
      ],
    },
    operator: {
      title: 'JMI Operator Layer',
      badge: 'Trust & Custody Backbone',
      role: 'Coordinates verification, assays, vault fulfilment, secure logistics, and escrow settlement.',
      features: [
        'Physical assay and weight verification at regional transit hubs',
        'Secured logistics coordination with insured transit cover',
        'Escrow and payment clearance orchestration',
        'Dispute resolution and BIS hallmarking compliance audits',
      ],
    },
    seller: {
      title: 'Seller Layer',
      badge: 'Distribution Engine',
      role: 'Supplies hallmarked stock, manages variant inventory, and prepares consignments.',
      features: [
        'Digital catalogue synchronization with live metal rates',
        'Real-time inventory lock and wholesale order acceptance',
        'Staged dispatch preparation with barcoded custody bags',
        'Accelerated commercial settlements on verified delivery',
      ],
    },
  };

  return (
    <section className="operating-layer-section" id="operating-layer">
      <div className="jmi-container">
        <div className="section-header-center">
          <div className="section-label">PLATFORM ARCHITECTURE</div>
          <h2 className="section-title">
            The <span className="gold-gradient-text">JMI Operating Layer</span>
          </h2>
          <p className="section-subtitle">
            JMI is not a standard listing marketplace. It is a governed digital operating network 
            that unifies buyers, sellers, and certified operational hubs into one synchronized trade fabric.
          </p>
        </div>

        {/* Network Diagram Graphic */}
        <div className="network-diagram-container">
          <div className="platform-crown">
            <div className="crown-badge">
              <span className="crown-icon">◆</span>
              <span className="crown-text">JMI OPERATING SYSTEM</span>
            </div>
          </div>

          <div className="tri-entity-grid">
            {/* BUYER NODE */}
            <div 
              className={`entity-node ${activeTab === 'buyer' ? 'active' : ''}`}
              onClick={() => setActiveTab('buyer')}
            >
              <div className="node-indicator">01</div>
              <div className="node-icon buyer-color">🛍️</div>
              <h4 className="node-title">BUYER</h4>
              <p className="node-summary">Sources products & places structured orders</p>
              <span className="node-action">Click to inspect →</span>
            </div>

            {/* OPERATOR NODE (CENTRAL DIFFERENTIATOR) */}
            <div 
              className={`entity-node central-node ${activeTab === 'operator' ? 'active' : ''}`}
              onClick={() => setActiveTab('operator')}
            >
              <div className="node-pulse-ring"></div>
              <div className="node-indicator highlight">GOVERNANCE</div>
              <div className="node-icon operator-color">⚡</div>
              <h4 className="node-title">OPERATOR</h4>
              <p className="node-summary">Coordinates verification, assay, vault & transaction clearance</p>
              <span className="node-action">Core Differentiator →</span>
            </div>

            {/* SELLER NODE */}
            <div 
              className={`entity-node ${activeTab === 'seller' ? 'active' : ''}`}
              onClick={() => setActiveTab('seller')}
            >
              <div className="node-indicator">02</div>
              <div className="node-icon seller-color">💎</div>
              <h4 className="node-title">SELLER</h4>
              <p className="node-summary">Supplies hallmarked inventory & fulfils wholesale orders</p>
              <span className="node-action">Click to inspect →</span>
            </div>
          </div>

          {/* Synchronized Order Network Base */}
          <div className="order-network-base">
            <div className="network-connector-lines"></div>
            <div className="network-hub-pill">
              <span className="lock-icon">🔒</span>
              <span>SYNCHRONIZED B2B ORDER & ESCROW NETWORK</span>
            </div>
          </div>
        </div>

        {/* Dynamic Detail Card */}
        <div className="entity-detail-panel">
          <div className="detail-header">
            <div className="detail-meta">
              <span className="detail-badge">{entityDetails[activeTab].badge}</span>
              <h3 className="detail-title">{entityDetails[activeTab].title}</h3>
            </div>
            <p className="detail-role">{entityDetails[activeTab].role}</p>
          </div>

          <div className="detail-points-grid">
            {entityDetails[activeTab].features.map((feat, idx) => (
              <div key={idx} className="detail-point-card">
                <span className="detail-bullet">✦</span>
                <span className="detail-point-text">{feat}</span>
              </div>
            ))}
          </div>

          <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'flex-end' }}>
            <Link 
              to={activeTab === 'buyer' ? '/buyer' : activeTab === 'operator' ? '/operator' : '/seller'} 
              className={`btn ${activeTab === 'operator' ? 'btn-primary' : 'btn-secondary'}`}
              style={activeTab === 'operator' ? { background: 'var(--tech-accent)', color: '#0a0a0b', border: 'none', fontWeight: 700 } : {}}
            >
              {activeTab === 'operator' 
                ? 'Explore Operator Layer & Earn ₹10L - ₹50L+ →' 
                : activeTab === 'buyer' 
                ? 'Explore Buyer Portal →' 
                : 'Explore Seller Portal →'}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OperatingLayer;
